export const ContactPageSchema = {
  "@context": "https://schema.org",
  "@type": "ContactPage",
  "name": "تماس با نواتل",
  "description": "راه‌های ارتباطی با تیم پشتیبانی و فروش نواتل - تلفن، ایمیل و آدرس دفتر مرکزی",
  "url": "https://navatel.ir/contact-us/",
  "mainEntity": {
    "@type": "LocalBusiness",
    "name": "نواتل",
    "legalName": "شرکت آریا سامانه",
    "url": "https://navatel.ir/",
    "image": "https://navatel.ir/img/icon.webp",
    "telephone": "+982182800000",
    "faxNumber": "+982182800000,6",
    "email": "office@sgas.ir",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "خیابان شریعتی، سه راه طالقانی، ابتدای خیابان خواجه نصیر الدین طوسی، پلاک ۲۴۷",
      "addressLocality": "تهران",
      "addressRegion": "تهران",
      "postalCode": "1611613611",
      "addressCountry": "IR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "35.7156",
      "longitude": "51.4376"
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Saturday",
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday"
      ],
      "opens": "00:00",
      "closes": "23:59"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+982182800000",
      "contactType": "customer service",
      "availableLanguage": "Persian",
      "areaServed": "IR"
    },
    "sameAs": [
      "https://www.instagram.com/navaboratebat/",
      "https://www.linkedin.com/company/navatel/"
    ]
  }
}
